// Module
var code = `<template>
  <require from="./page-number-widget.scss"></require>

  <!-- beautify ignore:start -->
  <style>
    .page-number-widget-\${id} {
      font-family: \${font || 'var(--dyn-default-font-family)'};
      font-size: \${fontSize ? fontSize + 'px' : 'var(--dyn-default-font-size)'};
      color: \${color | widgetTemplateColor:isInDashboard} !important;
      text-align: \${textAlign || 'left'};
    }
  </style>
  <!-- beautify ignore:end -->

  <div if.bind="reportPageElement.pageNumber" class="page-number-widget page-number-widget-\${id}">Side \${reportPageElement.pageNumber}</div>
</template>
`;
// Exports
export default code;